<div class="container">
  <div class="row">
    <div class="col-md-6">
      <pv-login></pv-login>
    </div>
    <div class="col-md-6" *ngIf="!disabled_d2c">
      <pv-register></pv-register>
    </div>
  </div>
</div>